import { render, staticRenderFns } from "./PersistSistemaView.vue?vue&type=template&id=d6742524&"
import script from "./PersistSistemaView.vue?vue&type=script&lang=ts&"
export * from "./PersistSistemaView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports